import React from 'react';
import { Button, makeStyles } from '@material-ui/core';
import { ITheme } from '../../themes/custom/ITheme';

import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import theme from './../../themes/GlobalTheme';
import { Grid, useMediaQuery } from '@mui/material';

interface Props {
    openBuyDialog: () => void;
    startSave: () => void;
    startSaveAs: () => void;
}

const useStyles = makeStyles((theme: ITheme) => ({
    button: {
        borderRadius: 10,
        margin: 0,
        width: '100%',
        whiteSpace: 'nowrap',
    },
    left: {},
    right: {},
    icon: {
        paddingRight: '10px',
    },
    menu: {
        marginTop: '43px',
        marginLeft: '1px',
        borderRadius: '0px',
        width: '100%',
    },
    expandIcon: {
        marginLeft: '10px',
    },
    editIcon: {
        marginRight: '10px',
        marginLeft: '10px',
    },
    closeIcon: {
        cursor: 'pointer',
    },
    text: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
}));

const BottomMenu: React.FC<Props> = (props) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { openBuyDialog, startSave, startSaveAs } = props;

    const isLgDown = useMediaQuery(theme.breakpoints.down('lg'));
    return (
        <React.Fragment>
            <Grid container justifyContent="flex-end" spacing="10px">
                <Grid item xs={isLgDown ? 3 : 2}>
                    <Button
                        variant="contained"
                        className={classes.button}
                        onClick={startSaveAs}
                    >
                        <span className={classes.text}>{t('Save as')}</span>
                    </Button>
                </Grid>
                <Grid item xs={isLgDown ? 3 : 2}>
                    <Button
                        variant="contained"
                        className={classes.button}
                        onClick={startSave}
                    >
                        <span className={classes.text}>{t('Save')}</span>
                    </Button>
                </Grid>
                <Grid item xs={isLgDown ? 6 : 3}>
                    <Button
                        variant="outlined"
                        color="secondary"
                        onClick={openBuyDialog}
                        className={clsx(classes.button, classes.right)}
                    >
                        <span className={classes.text}>
                            {t('Continue to sizes')}
                        </span>
                    </Button>
                </Grid>
            </Grid>
        </React.Fragment>
    );
};

export default BottomMenu;
